import React from "react";
import "./Projects.css";

const Projects = () => {
  return (
    <>
      <div className="continer project" id="projects">
        <h2 className="col-12 mt-3 mb-1 text-center text-uppercase">
          TOP RECENT PROJECTS
        </h2>
        <hr />
        <p className="pb-3 text-center">
          Here are some of my recent projects showcasing my expertise in full-stack development, 
          AI integration, and modern web technologies. Each project demonstrates different aspects 
          of my technical skills and problem-solving abilities.
        </p>
        {/* card design */}
        <div className="row" id="projects-grid">
  
            <div className="col-md-4">
              <div className="card rounded">
                <div className="card-image">
                  <span className="card-notify-badge">AI Platform</span>
                  <img
                    src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
                    alt="DocuSimilar - Document Analysis Platform"
                  />
                </div>
                <div className="card-image-overly m-auto mt-3">
                  <span className="card-detail-badge">React</span>
                  <span className="card-detail-badge">Node.js</span>
                  <span className="card-detail-badge">AI/ML</span>
                  <span className="card-detail-badge">FAISS</span>
                </div>
                <div className="card-body text-center">
                  <div className="project-title m-auto">
                    <h6 className="text-uppercase">
                      DocuSimilar
                    </h6>
                    <p className="project-description">
                      Advanced document similarity analysis platform using MERN stack with AI technologies, 
                      RAG, FAISS vector databases, and LangChain frameworks.
                    </p>
                  </div>
                  <a
                    className="project-btn"
                    href="https://github.com/anish0709/DcoumentSimilarityChecker"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: 'inline-block', visibility: 'visible', opacity: 1 }}
                  >
                    View
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card rounded">
                <div className="card-image">
                  <span className="card-notify-badge">Full stack</span>
                  <img
                    src="https://unctad.org/sites/default/files/2021-03/2021-03-15_eCommerceCOVID19report-1-1220x675px.jpg"
                    alt="project1"
                  />
                </div>
                <div className="card-image-overly m-auto mt-3">
                  <span className="card-detail-badge">Node</span>
                  <span className="card-detail-badge">Express</span>
                  <span className="card-detail-badge">react</span>
                  <span className="card-detail-badge">Mongodb</span>
                </div>
                <div className="card-body text-center">
                  <div className="project-title m-auto">
                    <h6 className="text-uppercase">
                      ecommerce
                    </h6>
                  </div>
                  <a
                    className="project-btn"
                    href="https://github.com/anish0709/ecommerce-project"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: 'inline-block', visibility: 'visible', opacity: 1 }}
                  >
                    View
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card rounded">
                <div className="card-image">
                  <span className="card-notify-badge">AI Assistant</span>
                  <img
                    src="https://images.unsplash.com/photo-1611224923853-80b023f02d71?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2039&q=80"
                    alt="Smart Email Assistant - AI-powered email tool"
                  />
                </div>
                <div className="card-image-overly m-auto mt-3">
                  <span className="card-detail-badge">Spring AI</span>
                  <span className="card-detail-badge">React</span>
                  <span className="card-detail-badge">Chrome Extension</span>
                  <span className="card-detail-badge">OpenAI</span>
                </div>
                <div className="card-body text-center">
                  <div className="project-title m-auto">
                    <h6 className="text-uppercase">
                      Smart Email Assistant
                    </h6>
                    <p className="project-description">
                      AI-powered email assistant with smart drafting, context-aware reply suggestions, 
                      and intelligent email prioritization using Spring AI and Chrome extension.
                    </p>
                  </div>
                  <a
                    className="project-btn"
                    href="https://github.com/anish0709/smart-email-assistant"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: 'inline-block', visibility: 'visible', opacity: 1 }}
                  >
                    View
                  </a>
                </div>
              </div>
            </div>
       
        </div>
      </div>
    </>
  );
};

export default Projects;
